import { useEffect } from 'react';
import api from '../lib/api';

/**
 * Fires a lightweight REST heartbeat every 30s while the user is logged in and the
 * tab is visible. Keeps `users.last_seen` fresh so presence on the Calls page is
 * accurate even during brief WebSocket reconnect flaps.
 */
export default function usePresenceHeartbeat(userId) {
  useEffect(() => {
    if (!userId) return undefined;

    let stopped = false;

    const ping = () => {
      if (stopped) return;
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      api.post('/me/presence/ping').catch(() => {});
    };

    // Fire immediately so this device registers as online right away
    ping();
    // Repeat every 30s
    const interval = setInterval(ping, 30_000);
    // Refresh when the tab becomes visible again
    const onVisibility = () => { if (document.visibilityState === 'visible') ping(); };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      stopped = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [userId]);
}
